export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '구분'}, {name: '평가작업명'}, {name: '재해형태'}, {name: '평가일시'}, {name: '실시기간'}, {name: '소속명'}, {name: '부서명'}, {name: '작성자'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContentRiskTypeList(func.getContent(value).riskAppraisalList) // 구분
      case 2: return func.getContent(value).inputB_3 // 평가작업명
      case 3: return func.getContentRiskList(func.getContent(value).riskAppraisalList)// 재해형태
      case 4: return func.getContent(value).inputB_4 // 평가일시
      case 5: return `${func.getContent(value).inputB_8}~${func.getContent(value).inputB_9}` // 실시기간
      case 6: return func.getContent(value).stdInfo.department // 소속명
      case 7: return func.getContent(value).stdInfo.com_name // 부서명
      case 8: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    if (nav.value.disasterType) returnData.push('content$body.disasterText*%[:default_disaster]%')

    switch (nav.value.searchType) {
    case '사업장명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case '구분': returnData.push('content$body.typeText*%[:default_skw]%'); break
    case '평가작업명': returnData.push('content$body.inputB_3*%[:default_skw]%'); break
    case '평가일시': returnData.push('content$body.inputB_4*%[:default_skw]%'); break
    case '소속명': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
    case '부서명': returnData.push('content$body.stdInfo.com_name*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
